(() => {
  const node = document.getElementById('fp-bundle-gift-config');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const root = window.Shopify?.routes?.root || '/';
  let busy = false, pending = false, pendingAdd = false;
  async function request(path, body) {
    const response = await fetch(root + path, {method: body ? 'POST' : 'GET', headers: {'Content-Type':'application/json','Accept':'application/json'}, ...(body ? {body:JSON.stringify(body)} : {})});
    if (!response.ok) throw new Error('Gift cart update failed');
    return response.json();
  }
  async function sync(allowAdd = false) {
    if (busy) { pending = true; pendingAdd ||= allowAdd; return; }
    busy = true;
    try {
      const cart = await request('cart.js');
      const hasBundle = cart.items.some(item => config.bundleIds.includes(item.product_id));
      const hasIncluded = cart.items.some(item => config.includedIds.includes(item.product_id));
      const bookCount = cart.items.reduce((count, item) => count + (config.bookIds.includes(item.product_id) ? item.quantity : 0), 0);
      const managed = cart.items.filter(item => item.properties?._fp_bundle_gift === 'true');
      const hasPads = cart.items.some(item => item.variant_id === config.variantId);
      let changed = false;
      if (managed.length && (hasIncluded || (!hasBundle && bookCount < 2))) {
        const updates = Object.fromEntries(managed.map(item => [item.key, 0]));
        await request('cart/update.js', {updates});
        changed = true;
      } else if (allowAdd && hasBundle && !hasIncluded && !hasPads && config.available) {
        await request('cart/add.js', {items:[{id:config.variantId,quantity:1,properties:{_fp_bundle_gift:'true'}}]});
        changed = true;
      }
      if (changed) document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
    } catch (error) {
      console.warn('Focused Plyrs: Geschenk konnte nicht automatisch aktualisiert werden. Der Geschenkbutton bleibt verfügbar.');
    } finally {
      busy = false;
      if (pending) { const nextAdd = pendingAdd; pending = false; pendingAdd = false; sync(nextAdd); }
    }
  }
  document.addEventListener('variant:added', () => sync(true));
  document.addEventListener('cart:updated', () => sync(false));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => sync(true), {once:true});
  else sync(true);
})();
